var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2154 0.366134L9.11304 6.46847C8.99677 6.58474 8.83907 6.65008 8.67464 6.65008C8.5102 6.65008 8.35251 6.58474 8.23624 6.46847L2.1339 0.366134C1.89948 0.131714 1.58156 0 1.25004 0C0.918518 0 0.600555 0.131714 0.366134 0.366134C0.131714 0.600555 0 0.918518 0 1.25004C0 1.58156 0.131714 1.89948 0.366134 2.1339L7.79076 9.55852C8.02518 9.79294 8.3431 9.92466 8.67462 9.92466C9.00614 9.92466 9.3241 9.79294 9.55852 9.55852L16.9831 2.1339C17.2176 1.89948 17.3493 1.58152 17.3493 1.25C17.3493 0.918475 17.2176 0.600555 16.9831 0.366134C16.7487 0.131714 16.4308 0 16.0993 0C15.7678 0 15.4498 0.131714 15.2154 0.366134Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellow);
export default __webpack_public_path__ + "static/media/Bellow.4477af30e0a1b54d97f7249acf81fec5.svg";
export { ForwardRef as ReactComponent };